export const ALERT_TYPES = Object.freeze({
  warning: 'warning',
  error: 'error',
  info: 'info',
  success: 'success'
});

export default { ALERT_TYPES };
